export default {
  link: {
    textDecoration: 'underline',
    cursor: 'pointer',
    padding: '0.3rem',
  },
}
